export default __webpack_public_path__ + "static/media/bild01.3314ddc2.webp";